import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { UserAvatarMenuProps } from '@entities/user';
import { useBreakpoint } from '@shared/lib/react';
import { withTheme } from '@shared/lib/theme';
import { BottomSheet, BottomSheetContent } from '@shared/ui/molecules';
import UserAvatarMenuContent from './UserAvatarMenuContent';
const UserAvatarMenu: FC<UserAvatarMenuProps> = ({
  open,
  onClose
}) => {
  const {
    isMobile
  } = useBreakpoint();
  return <>
      {isMobile ? <BottomSheet open={open} onClose={onClose}>
          <BottomSheetContent title="Профиль" onClose={onClose}>
            <UserAvatarMenuContent />
          </BottomSheetContent>
        </BottomSheet> : open && <UserAvatarDropdownContentWrapper>
            <UserAvatarMenuContent />
          </UserAvatarDropdownContentWrapper>}
    </>;
};
export default UserAvatarMenu;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.tertiary;
const UserAvatarDropdownContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "UserAvatarDropdownContentWrapper",
  class: "u5d8du2",
  propsAsIs: false,
  vars: {
    "u5d8du2-0": [_exp()]
  }
}));

require("./UserAvatarMenu.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./UserAvatarMenu.tsx");